module.exports = __webpack_public_path__ + "static/img/a2.9bed5db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet/a2.png
// module id = 0QLa
// module chunks = 0